import { useContext } from "react";
import { langContext, agentContext, messageContext } from "commons/contexts";
import { submitContactForm } from "commons/utils";

import style from "./style.module.scss";

type textType = { [key: string]: { [key: string]: string } };

function ContactForm() {
    const { lang } = useContext(langContext);
    const { agentData } = useContext(agentContext);
    const msgCon = useContext(messageContext);

    const languageTexts: textType = {
        nl: {
            photoText: "Hier komt een foto van U of van een medewerker met naam en naam bedrijf of een foto van een eigendom met de naam van uw bedrijf",
            bigTitle: "GRACIAS",
            title1: "Wij kijken uit naar uw reactie! Aarzel niet en zend een mail naar",
            title2: agentData.email || "Hier komt uw mail adres",
            title3: `of bel ons op ${agentData.phone || "Uw tel.nr."}`,

            footerTitle: "Gelieve het onderstaande formulier in te vullen, voor meer",
            footerText: "vrijblijvende informatie over Xtracosta becomes U kan ook het onderstaande formulier invullen voor meer vrijblijvende informatie over uhoe u in alle vertrouwen een nieuwbouw eigendom kan aankopen aan de Costa Blanca, Costa Calida of Costa del Sol. Een van onze specialisten neemt dan zo snel mogelijk contact met u op. Wij staan voor U klaar!",

            firstname: "Voornaam",
            lastname: "Familienaam",
            tel: "Tel.",
            email: "Email",
            message: "Bericht",
            send: "ZENDEN"
        },
        fr: {
            photoText: "Ici une photo de vous-même ou d'un employé avec le nom et le nom de votre entreprise ou une photo d'un bien immobilier avec le nom de votre entreprise.",
            bigTitle: "GRACIAS",
            title1: "Nous attendons votre réaction avec impatience! N'hésitez pas et envoyez un mail à",
            title2: agentData.email || "Ici votre adresse email",
            title3: `ou appelez-nous au ${agentData.email || "Votre numéro de téléphone"}`,

            footerTitle: "",
            footerText: "Veuillez remplir le formulaire ci-dessous pour obtenir plus d'informations sur Xtracosta (sans engagement). Vous pouvez également remplir le formulaire pour obtenir plus d'informations sur la manière d'acheter une nouvelle propriété sur la Costa Blanca, Costa Calida ou Costa del Sol en toute confiance. L'un de nos spécialistes vous contactera dans les plus brefs délais. Nous sommes là pour vous!",

            firstname: "Prénom",
            lastname: "Nom de famille",
            tel: "Tél.",
            email: "Email",
            message: "Message",
            send: "Envoyer"
        },
    };

    const text = languageTexts[lang] || {};

    return (
        <div className={style.root}>
            <div className={style.whiteContainer}>
                <div className={style.photoHalf}>
                    <div className={style.photo} />
                    <div className={style.text}>{text.photoText || ""}</div>
                </div>

                <div className={style.textHalf}>
                    <div className={style.content}>
                        <div className={style.yellowTitle + " " + style.bigTitle + " " + style.titles}>{text.bigTitle || ""}</div>
                        <div className={style.blackTitle + " " + style.titles}>
                            {text.title1 || ""} <br />
                            {text.title2 || ""} <br />
                            {text.title3 || ""}
                        </div>
                        {/* <div className={style.yellowTitle + " " + style.titles}>Hier komt uw mail adres</div>
                        <span>of bel ons op </span>
                        <span className={style.yellowTitle}>Uw tel.nr.</span> */}

                        <div className={style.smallTextBox}>
                            <div className={style.smallTextBlock + " " + style.smallText}>{text.footerTitle || ""}</div>
                            <div className={style.smallTextBlock + " " + style.smallText}>{text.footerText || ""}</div>
                        </div>

                        <form className={style.form} onSubmit={
                            (e) => {
                                e.preventDefault();
                                submitContactForm(e.currentTarget, msgCon.setMessage);
                            }
                        }>
                            <div className={style.inputs + " " + style.smallerText}>
                                <input type="text" name="firstname" placeholder={text.firstname || ""} />
                                <input type="text" name="lastname" placeholder={text.lastname || ""} />
                                <input type="text" name="phone" placeholder={(text.tel || "") + " *"} required />
                                <input type="text" name="email" placeholder={text.email || ""} />
                            </div>
                            <textarea className={style.smallText} name="message" placeholder={(text.message || "") + " *"} required />

                            <div className={style.buttonContainer + " " + style.smallerText}>
                                <button>{text.send || ""} </button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default ContactForm;